import { EASY_MODE_STEP } from '@demandproai/shared';

// re-exported under the plural name the wizard already uses; the shared enum is the source because
// the agent's gap report names a step too
export const EASY_MODE_STEPS = EASY_MODE_STEP;

export const EASY_MODE_TOTAL_STEPS = Object.keys(EASY_MODE_STEPS).length;

export const EASY_MODE_STEP_LABELS = {
  [EASY_MODE_STEPS.CASE_INTAKE]: 'Case Intake',
  [EASY_MODE_STEPS.DOCUMENT_UPLOAD]: 'Document Upload',
  [EASY_MODE_STEPS.DEMAND_GENERATION]: 'Demand Generation'
};

// the stepper names the outcome, the footer names the input being collected
export const EASY_MODE_FOOTER_LABELS = {
  [EASY_MODE_STEPS.CASE_INTAKE]: 'Case Intake',
  [EASY_MODE_STEPS.DOCUMENT_UPLOAD]: 'Document Upload',
  [EASY_MODE_STEPS.DEMAND_GENERATION]: 'AI Context'
};

export const EASY_MODE_STEP_ORDER = Object.values(EASY_MODE_STEPS);

export const getNextEasyModeStep = (step) => Math.min(step + 1, EASY_MODE_STEPS.DEMAND_GENERATION);

export const getPreviousEasyModeStep = (step) => Math.max(step - 1, EASY_MODE_STEPS.CASE_INTAKE);

export const isFirstEasyModeStep = (step) => step === EASY_MODE_STEPS.CASE_INTAKE;

export const isLastEasyModeStep = (step) => step === EASY_MODE_STEPS.DEMAND_GENERATION;
